<div class="extra-item" [ngClass]="{selected: modifier.selectedQuantity}"
	 *ngIf="modifier.maxAmount !== 1; else checkBoxMod">
	<span class="extra-name">{{getName(modifier)}}</span>

	<div class="extra-right">

        <span class="extra-price">
            {{modifier.calculatedPrice | currency:('CURRENCY_SYMBOL' | translate):('CURRENCY_SIGN' | translate)}}
        </span>

		<div class="extra-buttons">
			<button
				class="extra-button extra-remove"
				mat-icon-button aria-label="remove"
				(tap)="decrease()"
				[style.visibility]="modifier.minAmount >= modifier.selectedQuantity ? 'hidden' : 'visible'"
				[disabled]="modifier.minAmount >= modifier.selectedQuantity">
				<mat-icon>remove</mat-icon>
			</button>

			<span class="extra-count">{{modifier.selectedQuantity}}</span>

			<button
				class="extra-button extra-add"
				mat-icon-button aria-label="add"
				(tap)="increase()"
				[style.visibility]="(groupIsMaxFull || modifier.maxAmount <= modifier.selectedQuantity) ? 'hidden' : 'visible'"
				[disabled]="groupIsMaxFull">
				<mat-icon>add</mat-icon>
			</button>
		</div>

	</div>
</div>

<ng-template #checkBoxMod>
	<app-checkbox-select
		[modifier]="modifier"
		[groupIsMaxFull]="false"
	>
	</app-checkbox-select>
</ng-template>
